<template>
  <div>
    <section-collapseable
      title="Tasks"
      :sub-title="subtitle"
      button-text="Task"
      @add="$refs.taskModal.open()"
      :collapseable="!!tasks.length"
      :hide-initial-always="!isLoading && !tasks.length"
      hide-initial-when-expanded
      :is-loading="isLoading"
    >
      <!-- Next Task -->
      <template v-if="nextTask">
        <task-item
          :task="nextTask"
          is-next-task
          @edit="openEditTaskModal"
        ></task-item>
      </template>

      <!-- All Tasks -->
      <template v-slot:expanded>
        <template v-if="tasks.length">
          <div class="mt-50">
            <task-item
              v-for="task in incompleteTasks"
              :key="task.id"
              :task="task"
              @edit="openEditTaskModal"
            ></task-item>
          </div>

          <template v-if="completedTasks.length">
            <div v-if="hideCompleted" class="flex flex-centered my-50">
              <button-link
                @click="hideCompleted = false"
              >View {{ completedTasks.length }} completed task{{ completedTasks.length ? "s" : "" }}
              </button-link>
            </div>

            <template v-else>
              <div class="flex flex-centered">
                <button-link
                  @click="hideCompleted = true"
                >Hide completed task{{ completedTasks.length ? "s" : "" }}
                </button-link>
              </div>

              <task-item
                v-for="task in completedTasks"
                :key="task.id"
                :task="task"
                @edit="openEditTaskModal"
              ></task-item>
            </template>
          </template>

          <div v-if="nextPageUrl" class="flex flex-centered mt-150">
            <button-outlined @click="loadMoreTasks" :loading="isLoadingMore">Load More Tasks</button-outlined>
          </div>
        </template>

        <p v-else class="no_tasks">This lead has no tasks, yet.</p>
      </template>
    </section-collapseable>

    <!-- Task Modal -->
    <modal-container>
      <modal-crud-form
        ref="taskModal"
        title="Task"
        form-component="task-form"
        is-double-column
      ></modal-crud-form>
    </modal-container>
  </div>
</template>

<script>
import TaskItem from "../components/TaskItem";
import {ENUMS} from "../../../services/enums";
import api from "../../../api";

export default {
  name: "LeadTasks",
  components: {TaskItem},
  props: {
    isLoading: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      hideCompleted: true,
      isLoadingMore: false,
      nextPageUrl: null
    };
  },
  computed: {
    tasks() {
      if (! this.$store.state.activeRecord.tasks.data) return [];

      this.nextPageUrl = this.$store.state.activeRecord.tasks.links.next;

      return this.$store.state.activeRecord.tasks.data.sort((a, b) => new Date(a.due_at) - new Date(b.due_at));
    },
    tasksTotal() {
      if (! this.$store.state.activeRecord.tasks.data) return 0;
      return this.$store.state.activeRecord.tasks.meta.total;
    },
    completedTasks() {
      return this.tasks.filter(task => {
        if (task.status === ENUMS.TaskStatusEnum.Complete.value) return true;

        return task.status === ENUMS.TaskStatusEnum.Ignored.value;
      });
    },
    incompleteTasks() {
      return this.tasks.filter(task => task.status === ENUMS.TaskStatusEnum.Incomplete.value);
    },
    subtitle() {
      if (this.tasks.length === 0) return "0";

      // compares count from init api call and complete task filter to make the count up to date when updating tasks
      const initCompletedCount = this.$store.state.activeRecord.tasksCompletedCount;
      const completedFilterCount = this.completedTasks.length;
      const completedCount = (initCompletedCount > completedFilterCount) ? initCompletedCount : completedFilterCount;

      return `${completedCount}/${this.tasksTotal} complete`;
    },
    nextTask() {
      if (this.incompleteTasks.length === 0) return null;

      return this.incompleteTasks[0];
    }
  },
  methods: {
    openEditTaskModal(task) {
      this.$refs.taskModal.open(task);
    },
    loadMoreTasks() {
      this.isLoadingMore = true;
      return api.custom.get(this.nextPageUrl)
        .then(res => {
          const copy = this.$utils.clone(this.tasks);
          const newData = {
            data: [...copy, ...res.data.data],
            links: res.data.links,
            meta: res.data.meta
          }

          this.$store.commit("setActiveRecordProp", {prop: 'tasks', value: newData});
          this.nextPageUrl = res.data.links.next;
        })
        .finally(() => this.isLoadingMore = false)
    }
  },
};
</script>

<style lang="scss" scoped>
@import "../../../styles/variables/variables";

.no_tasks {
  margin: 1rem 0;
}
</style>
